import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Home2 } from "iconsax-react";
import { FC } from "react";
import { Link } from "react-router-dom";

type BreadcrumbsProps = {
  editionName: string;
  forPreviousEditions?: boolean;
};

const ResultsPageBreadcrumbs: FC<BreadcrumbsProps> = (props) => {
  if (!props.forPreviousEditions) {
    return null;
  }

  return (
    <Breadcrumb>
      <BreadcrumbList className="mb-0">
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={"/"}>
              <Home2 size={14} className="-mt-0.5 mr-1 inline" /> Inicio
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/previous-editions">Ediciones anteriores</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage>
            Reporte de resultados: {props.editionName}
          </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default ResultsPageBreadcrumbs;
